import moment from 'moment'
import { saveAs } from 'file-saver'
import { moneyFormat } from 'easyguide'
import DOWNLOAD_TYPE from 'utils/downloadType'

const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  isFetchingDownload: false,
  isFetchedDownload: false,
  successDownload: false,
  errorDownload: false,
  origin: [],
  selectedOrigin: null,
  startDate: moment().subtract(30, 'days'),
  defaultStartDate: null,
  displayStartDate: null,
  endDate: moment(),
  displayEndDate: null,
  summary: null,
  noContent: false
}

export const ACTION_TYPES = {
  ACCOUNT_STATEMENT_REQUEST: 'ACCOUNT_STATEMENT_REQUEST',
  ACCOUNT_STATEMENT_SUCCESS: 'ACCOUNT_STATEMENT_SUCCESS',
  ACCOUNT_STATEMENT_ERROR: 'ACCOUNT_STATEMENT_ERROR',

  ACCOUNT_STATEMENT_REPORT_REQUEST: 'ACCOUNT_STATEMENT_REPORT_REQUEST',
  ACCOUNT_STATEMENT_REPORT_SUCCESS: 'ACCOUNT_STATEMENT_REPORT_SUCCESS',
  ACCOUNT_STATEMENT_REPORT_ERROR: 'ACCOUNT_STATEMENT_REPORT_ERROR',

  ACCOUNT_STATEMENT_DOWNLOAD_REQUEST: 'ACCOUNT_STATEMENT_DOWNLOAD_REQUEST',
  ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS: 'ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS',
  ACCOUNT_STATEMENT_DOWNLOAD_ERROR: 'ACCOUNT_STATEMENT_DOWNLOAD_ERROR',

  ACCOUNT_STATEMENT_SELECT_ORIGIN: 'ACCOUNT_STATEMENT_SELECT_ORIGIN',

  ACCOUNT_STATEMENT_SET_NO_CONTENT: 'ACCOUNT_STATEMENT_SET_NO_CONTENT',

  ACCOUNT_STATEMENT_START_DATE: 'ACCOUNT_STATEMENT_START_DATE',
  ACCOUNT_STATEMENT_DEFAULT_START_DATE: 'ACCOUNT_STATEMENT_DEFAULT_START_DATE',
  ACCOUNT_STATEMENT_END_DATE: 'ACCOUNT_STATEMENT_END_DATE',

  ACCOUNT_STATEMENT_CLEAR_STORE: 'ACCOUNT_STATEMENT_CLEAR_STORE'
}

const getItemSelection = (state, payload) => {
  const newState = { ...state, selectedOrigin: payload }
  return newState
}

const getOriginAccounts = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    origin: []
  }
  const accounts = data || []
  newState.origin = accounts.filter(item => item.accountType !== 'TD')
    .map(item => ({
      ...item,
      key: item.accountTypeId,
      value: item.description
    }
    ))

  const deposit = newState.origin.filter(item => item.accountType === 'Deposit')

  if (deposit.length) {
    return getItemSelection(newState, deposit[0])
  }

  return newState
}

const getReport = (state, { data: { value } }) => {
  const newState = {
    ...state,
    isFetching: false,
    noContent: false,
    summary: {
      properties: [
        {
          key: 'settlementDate',
          value: 'Liquid.'
        },
        {
          key: 'movementDate',
          value: 'Movim.'
        },
        {
          key: 'description',
          value: 'Histórico',
          bodyStyle: {
            textAlign: 'left'
          }
        },
        {
          key: 'value',
          value: 'Lançamento',
          bodyStyle: {
            whiteSpace: 'nowrap'
          },
          class: 'gb-hide'
        },
        {
          key: 'balance',
          value: 'Saldo',
          bodyStyle: {
            whiteSpace: 'nowrap'
          },
          class: 'gb-hide'
        }
      ],
      data: [],
      finalBalance: null,
      initialBalance: null
    }
  }
  newState.summary.data = value.statements.map(statement => ({
    settlementDate: moment(statement.settlementDate).format('DD/MM/YYYY'),
    movementDate: moment(statement.movementDate).format('DD/MM/YYYY'),
    description: statement.description,
    value: moneyFormat(statement.value),
    balance: moneyFormat(statement.balance)
  }))
  newState.summary.finalBalance = moneyFormat(value.finalBalance)
  newState.summary.initialBalance = moneyFormat(value.initialBalance)

  return newState
}

export const getAccountStatement = () => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_REQUEST
})

export const getAccountStatementReport = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_REPORT_REQUEST,
  payload
})

export const getAccountStatementDownload = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_DOWNLOAD_REQUEST,
  payload
})

export const setItemOrigin = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_SELECT_ORIGIN,
  payload
})

export const setStartDate = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_START_DATE,
  payload
})

export const setDefaultStartDate = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_DEFAULT_START_DATE,
  payload
})

export const setEndDate = payload => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_END_DATE,
  payload
})

export const clearAccountStatementStore = () => ({
  type: ACTION_TYPES.ACCOUNT_STATEMENT_CLEAR_STORE
})

const accountStatement = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.ACCOUNT_STATEMENT_SET_NO_CONTENT:
      return {
        ...state,
        noContent: true
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_SUCCESS:
      return getOriginAccounts(state, action.payload)
    case ACTION_TYPES.ACCOUNT_STATEMENT_ERROR:
      return {
        ...state,
        isFetched: true,
        error: true,
        data: action.payload
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_SELECT_ORIGIN:
      return getItemSelection(state, action.payload)
    case ACTION_TYPES.ACCOUNT_STATEMENT_REPORT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_REPORT_SUCCESS:
      return getReport(state, action.payload)
    case ACTION_TYPES.ACCOUNT_STATEMENT_REPORT_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true,
        summary: null,
        data: action.payload
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_DOWNLOAD_REQUEST:
      return {
        ...state,
        isFetchingDownload: true
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS:
      if (DOWNLOAD_TYPE.RESPONSE_TYPE[action.payload.format]) {
        saveAs(
          new Blob([action.payload.response.data], { type: action.payload.format }),
          action.payload.fileName
        )
        return {
          ...state,
          isFetchedDownload: true,
          isFetchingDownload: false,
          successDownload: true
        }
      }
      return {
        ...state,
        isFetchedDownload: true,
        isFetchingDownload: false,
        successDownload: false
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_DOWNLOAD_ERROR:
      return {
        ...state,
        isFetchedDownload: true,
        isFetchingDownload: false,
        errorDownload: true,
        data: action.payload
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_START_DATE:
      return {
        ...state,
        startDate: action.payload,
        endDate: null,
        displayStartDate: moment(action.payload).format('DD/MM/YYYY'),
        displayEndDate: null
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_DEFAULT_START_DATE:
      return {
        ...state,
        defaultStartDate: action.payload,
        endDate: null,
        displayStartDate: moment(action.payload).format('DD/MM/YYYY'),
        displayEndDate: null
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_END_DATE:
      return {
        ...state,
        endDate: action.payload,
        displayEndDate: moment(action.payload).format('DD/MM/YYYY')
      }
    case ACTION_TYPES.ACCOUNT_STATEMENT_CLEAR_STORE:
      return initialState
    default:
      return state
  }
}

export default accountStatement
